import { Navigate, Outlet } from 'react-router-dom'
import PrivilegesUtil from './PrivilegesUtil'
import Privileges from '../../const/Privileges'

const AdminRoute = ({ user }: { user: any }) => {
    return user && PrivilegesUtil.hasPrivilege(user, Privileges.ADMIN) ? <Outlet /> : <Navigate to='/' />
}

export default AdminRoute
